import '../../../scss/common/components/qpig.scss'
import './QpigProcessSteps'

import {
  Body2,
  Box,
  Display1,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@sainsburys-tech/fable'
import React from 'react'

import { IAdditionalInformation } from '../../types/IAdditionalInformation'
import { QpigTypes } from '../../types/IQpigTypes'
import QpigPLUCode from './QpigPLUCode'

interface IQpigProcessStepsTableProps {
  additionalInformationList: IAdditionalInformation[]
  pluCodes: string[]
}

const QpigPackagingCodeTable = ({
  additionalInformationList,
  pluCodes,
}: IQpigProcessStepsTableProps) => {
  const hasPackagingCodes = (): boolean => {
    if (additionalInformationList) {
      return additionalInformationList.some(
        (additionalInformation) =>
          additionalInformation.type === QpigTypes.QpigPackagingCodes,
      )
    } else {
      return false
    }
  }

  const getPackagingCodes = () => {
    if (
      additionalInformationList === null ||
      additionalInformationList === undefined
    ) {
      return <tr />
    }
    return additionalInformationList
      .filter(
        (additionalInformation) =>
          additionalInformation.type === QpigTypes.QpigPackagingCodes,
      )
      .map((additionalInformation, i) => {
        const rawPackagingQpig = additionalInformation.description
        // Removes the QPIG Packaging Code and then the following Number.
        const packagingDescription = rawPackagingQpig
          .replace(/^QPIG Packaging Code \d+/, '')
          .replace(/((\d+\/\d+)|(\d+))$/, '')

        // Checks final part of the string for numbers or numbers seperated by /.
        const skuIndex = rawPackagingQpig.search(
          /((\d+\/\d+)|(\d+)|([sS]upplied in product case))$/,
        )
        const packagingCode = rawPackagingQpig
          .substring(skuIndex)
          .replace(/([sS]upplied in product case)$/, '-')

        return (
          <TableRow data-testid={`packaging-code-row-${i}`} key={i}>
            <TableCell>
              <Body2>{packagingDescription}</Body2>
            </TableCell>
            <TableCell>
              <Body2>{packagingCode}</Body2>
            </TableCell>
          </TableRow>
        )
      })
  }

  const tablePackagingCodes = () => (
    <Box
      padding='none'
      textAlign='left'
      className='c-qpig-table-fixed-width'
      testid='qpig-packaging-table-box'
    >
      <Table
        testid='qpig-packaging-code-table'
        className='c-qpig-border-line'
        style={{ width: '100%' }}
      >
        <TableHeader>
          <TableRow data-testid='packaging-code-row'>
            <TableCell colSpan={2} className='c-qpig-ingredient-header-cell'>
              <Display1>Packaging codes</Display1>
            </TableCell>
          </TableRow>
        </TableHeader>

        <TableBody style={{ width: '100%' }}>{getPackagingCodes()}</TableBody>
      </Table>
    </Box>
  )

  return (
    <Box className='c-qpig-table-margin c-qpig-table-fixed-width'>
      {hasPackagingCodes() && tablePackagingCodes()}
      <Box style={{ textAlign: 'left', paddingLeft: '8px' }}>
        <QpigPLUCode pluCodes={pluCodes} />
      </Box>
    </Box>
  )
}

export default QpigPackagingCodeTable
